import { useLanguage } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";

export default function HeroSection() {
  const { t } = useLanguage();

  return (
    <section className="w-full bg-[#fefce8] py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10">
          {/* LEFT */}
          <div className="flex-1">
            <h1 className="text-3xl md:text-[42px] font-black text-secondary leading-tight mb-5">
              {t("weather.h1")}
            </h1>
            <p className="text-base text-[#374151] leading-relaxed mb-6 max-w-lg">
              {t("weather.subhead")}
            </p>
            <div className="flex flex-col sm:flex-row items-start gap-3">
              <a
                href="tel:+17863774452"
                className="inline-flex items-center gap-2 bg-[#ea580c] text-white px-6 py-3 text-sm font-bold rounded-lg hover:bg-[#c2410c] transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line" />
                Call (786) 377-4452
              </a>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 bg-transparent border-2 border-[#064e3b] text-secondary px-6 py-3 text-sm font-bold rounded-lg hover:bg-secondary hover:text-white transition-colors whitespace-nowrap"
              >
                Get Phone Quote
              </Link>
            </div>
          </div>

          {/* RIGHT */}
          <div className="flex-1">
            <img
              src="https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/b2bc92b9-01e9-406e-a5e4-aef2f500d1eb_Weatherstripping--Sealing-Miami.jpg?v=479782bfccbf28769c9f74e0d61f9440"
              alt="Weatherstripping window sealing draft stop Miami-Dade homes"
              className="rounded-xl w-full object-cover max-w-[520px] mx-auto"
              onError={(e) => {
                (e.target as HTMLImageElement).src = "https://placehold.co/520x360/e2e8f0/1e293b?text=WEATHERSTRIPPING";
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}